// This string connects the anchor address of the skip navigation
// To an element with the same ID
export const SKIP_NAVIGATION = 'skip-navigation'
